<template>
  <div>
    <generic-container
      :title="$t('teacher organization tree list')"
      icon="list"
      style="margin: 0 15px"
      :searchable="true"
      @filter="filter"
      :show_refresh="true"
      :header_buttons="header_buttons"
      :show_plus="true"
      @refresh="init"
      @add="add"
      ref="generic_container"
      :configurable="false"
      v-bind:configure_modal="configure_modal"
    >
      <div class="ui three link cards">
        <div
          class="ui card"
          v-for="(itm, idx) in list"
          :key="idx"
          @click="load(itm)"
          v-show="itm.must_show"
          v-bind:class="{
            blue: itm.status_code == 'A',
            red: itm.status_code == 'I',
          }"
        >
          <div class="content">
            <img
              class="right floated mini ui image"
              src="/images/icons/teacher_organizational_diagram.png"
            />
            <a class="header">{{ itm.name }}</a>
            <div class="content">
              {{
                itm.staff_rating_template ? itm.staff_rating_template.name : ""
              }}
            </div>
            <div class="description">
              {{ itm.description }}
            </div>
          </div>
        </div>
      </div>
    </generic-container>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";

export default {
  name: "TeacherOrganizationTreeList",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      configure_modal: ConfigureModal,
      list: [],
      header_buttons: [
        { icon: "left arrow", tooltip: this.$t("back"), click: this.back },
      ],
    };
  },
  computed: {},
  methods: {
    load(itm) {
      let vm = this;
      // local_api(vm, "post", "/feedback_360/tree/do-get", { i: itm.uuid })
      local_api(vm, "post", "/staff_rating/teacher_organization/do-get", {
        i: itm.uuid,
      })
        .then((r) => {
          vm.$emit("load", r);
          vm.$refs.generic_container.toggle();
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    // update(chart) {
    //   let trgt = this.list.find((n) => n.uuid == chart.uuid);
    //   if (trgt) {
    //     trgt.name = chart.name;
    //     trgt.description = chart.description;
    //   } else this.list.push(chart);
    // },
    delete(uuid) {
      let trgtIdx = this.list.findIndex((n) => n.uuid == uuid);
      if (trgtIdx >= 0) this.list.splice(trgtIdx);
    },
    filter(filter) {
      let vm = this;
      if (filter) {
        vm.list.map((el) => {
          // console.log(el);
          el.must_show =
            el.name.includes(filter) || el.description.includes(filter);
        });
      } else {
        vm.list.map((el) => {
          el.must_show = true;
        });
      }
    },
    init() {
      let vm = this;
      // local_api(vm, "post", "/feedback_360/tree/do-get-list")
      local_api(vm, "post", "/staff_rating/teacher_organization/do-get-list")
        .then((r) => {
          if (r && r.length) {
            vm.list = r.map((e) => {
              e.must_show = true;
              return e;
            });
          }
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    add() {
      this.$emit("add");
      this.$refs.generic_container.toggle();
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    let vm = this;
    vm.init();
  },
  watch: {},
};
</script>

<style></style>
